<template>
  <div>
    <v-menu
      bottom
      left
      min-width="100"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          icon
          outlined
          color="primary"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list
        dense
        class="pa-0"
      >
        <v-list-item
          v-if="posServer.approvedStatus"
          :disabled="!$store.getters.checkUserPrivilege('SERVER_SETUP')"
          @click="$emit('edit', posServer.id,'edit')"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-circle-edit-outline
            </v-icon>
            Edit
          </v-list-item-title>
        </v-list-item>
        <v-divider />

        <v-list-item
          v-if="posServer.activeStatus"
          :disabled="!$store.getters.checkUserPrivilege('SERVER_SETUP')"
          @click="inActivate()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="error"
            >
              mdi-lightbulb-off
            </v-icon>
            In-activate
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="!posServer.approvedStatus || !posServer.activeStatus"
          :disabled="!$store.getters.checkUserPrivilege('SERVER_SETUP')"
          @click="activate(posServer)"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-lightbulb-on
            </v-icon>
            Activate
          </v-list-item-title>
        </v-list-item>
        <v-divider />
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { failure } from "@/mixins/common";

export default {
  name: "PosServerOptions",
  components: {
  },
  mixins: [failure],
  props: {
    posServer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    };
  },
  methods: {
    inActivate() {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to inactivate?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http
            .put(`${this.ADMIN_API_URL}/posServers/${this.posServer.id}/inactivate`)
            .then(
              (data) => {
                this.handleSuccess(data.body);
              },
              (failure) => {
                this.handleFailure(failure);
              }
            );
        });
    },
    activate(posServer) {
      if(!posServer.approvedStatus){
        this.$emit("edit",posServer.id,"activate");
        return;
      }
    

      this.$root.$confirm
        .open("Confirm", "Are you sure you want to activate?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http
            .put(`${this.ADMIN_API_URL}/posServers/${this.posServer.id}/activate`)
            .then(
              (data) => {
                this.handleSuccess(data.body);
              },
              (failure) => {
                this.handleFailure(failure);
              }
            );
        });
    },
    handleSuccess(response) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.message
      });
      this.$emit("reload");
    }
  }
};
</script>
